import { useState } from 'react'
import { Form } from 'antd'

const useTaskModals = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isCompleteModalVisible, setIsCompleteModalVisible] = useState(false)
  const [selectedTask, setSelectedTask] = useState(null)
  const [form] = Form.useForm()
  const [completeForm] = Form.useForm()

  // Show add task modal
  const showModal = () => {
    setIsModalVisible(true)
  }

  // Show complete task modal
  const showCompleteModal = (task) => {
    setSelectedTask(task)
    setIsCompleteModalVisible(true)
  }

  // Cancel add task modal
  const handleCancel = () => {
    setIsModalVisible(false)
    form.resetFields()
  }

  // Cancel complete task modal
  const handleCompleteCancel = () => {
    setIsCompleteModalVisible(false)
    completeForm.resetFields()
  }

  // Submit add task form
  const handleAdd = () => {
    form
      .validateFields()
      .then((values) => {
        // In a real application, this would add the new task to the database
        setIsModalVisible(false)
        form.resetFields()
      })
      .catch((info) => {})
  }

  // Submit complete task form
  const handleComplete = () => {
    completeForm
      .validateFields()
      .then((values) => {
        // In a real application, this would update the task status in the database
        setIsCompleteModalVisible(false)
        completeForm.resetFields()
      })
      .catch((info) => {})
  }

  return {
    isModalVisible,
    isCompleteModalVisible,
    selectedTask,
    form,
    completeForm,
    showModal,
    showCompleteModal,
    handleCancel,
    handleCompleteCancel,
    handleAdd,
    handleComplete
  }
}

export default useTaskModals
